import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import commonFunction from '../../../commonFunction'
import {
    Validator
} from 'vee-validate'

export default {
    name: 'changepassword',
    components: {},
    props: [],
    data() {
        return {
            oldpassword: '',
            newpassword: '',
            confirmpassword: '',
            localwarehouseid: '',
            localclientid: '',
            loginuserid: ''
        }
    },
    computed: {

    },
    mounted() {
        var permissionEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.localwarehouseid = userdetail[0].warehouseid;
        this.localclientid = userdetail[0].clientid;
        this.loginuserid = userdetail[0].userid;
    },
    methods: {
        changePassword() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

                this.input = ({
                    userid: this.loginuserid,
                    warehouseid: this.localwarehouseid,
                    oldpassword: this.oldpassword,
                    newpassword: this.newpassword
                })
                axios({
                        method: 'POST',
                        'url': apiUrl.api_url + 'changepassword',
                        'data': this.input,
                        headers: commonFunction.getusertoken(),

                    })
                    .then((response) => {
                        if (response.data.data.code == 0) {
                            this.$alertify.success(response.data.data.msg);
                            localStorage.removeItem('permissiondata')
                            localStorage.removeItem('userdetail')
                            localStorage.removeItem('userToken')
                            localStorage.removeItem('isLoggedIn')
                            this.$router.push('/login')
                        } else if (response.data.data.code == -1) {
                            this.$alertify.error(response.data.data.msg)
                        }
                    })
                    .catch((httpException) => {
                        console.error('exception is:::::::::', httpException)
                    })
        },
        resetForm(){
          this.oldpassword = '';
          this.newpassword = '',
          this.confirmpassword = '';
          this.$validator.reset();
          this.errors.clear();
        },
        onSubmit: function(event) {
            this.$validator
                .validateAll()
                .then(() => {
                    console.log("form is valid", this.model);
                    event.target.reset();
                })
                .catch(() => {
                    console.log("errors exist", this.errors);
                });
        }

    }
}



// WEBPACK FOOTER //
// ./src/views/components/changepassword/changepassword.component.js